// extracted by mini-css-extract-plugin
export default {"journalModalContainer":"Journal_journalModalContainer__rt-TH","journalFormActions":"Journal_journalFormActions__cT4PJ"};